var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.558 1.696c.152-.177.228-.266.319-.299a.363.363 0 01.245 0c.09.033.167.122.319.299l5.273 6.152c.261.305.392.458.395.587a.364.364 0 01-.133.29c-.1.082-.302.082-.704.082H9.849c-.272 1.55-.752 2.97-1.931 4.024a7.02 7.02 0 01-4.675 1.786h-.445c.918-.762 2-1.808 2.517-2.884.455-.948.802-1.879.873-2.926h-3.46c-.403 0-.604 0-.704-.082a.363.363 0 01-.134-.29c.004-.13.134-.282.396-.587l5.273-6.152z",
    fill: "url(#up_icon_svg__paint0_linear_15979_5517)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.434 5.281a.506.506 0 00.087.722.533.533 0 00.738-.088L8.381 4.52a.506.506 0 00-.087-.721.533.533 0 00-.737.087L6.434 5.281zM5.62 6.45a.518.518 0 00-.445.583c.041.28.307.475.594.434h.003a.518.518 0 00.445-.584.522.522 0 00-.595-.434H5.62z",
    fill: "#fff"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "up_icon_svg__paint0_linear_15979_5517",
    x1: 8,
    y1: 1.544,
    x2: 2.553,
    y2: 16.251,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.464,
    stopColor: "#E84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.911,
    stopColor: "#EE8144",
    stopOpacity: 0.408
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E84",
    stopOpacity: 0
  })))));
}
export default SvgUpIcon;